import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { fetchTaskGroupSettingsTableAndFilterSchema } from "model/TaskGroupSettingsModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const TaskGroupSettingsContext = createContext();

export const TaskGroupSettingsProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [taskGroupSettingsContextData, setTaskGroupSettingsContextData] = useState();

  const fetchTaskGroupSettingsContextData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema(
        "metadata:taskGroupSettings",
        () => fetchTaskGroupSettingsTableAndFilterSchema([])
      );
      if (response?.success) {
        setTaskGroupSettingsContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetchMetadataSchema]);

  const value = useMemo(
    () => ({
      fetchTaskGroupSettingsContextData,
      taskGroupSettingsContextData,
      loading,
      error,
    }),
    [fetchTaskGroupSettingsContextData, taskGroupSettingsContextData, loading, error]
  );

  return (
    <TaskGroupSettingsContext.Provider value={value}>
      {children}
    </TaskGroupSettingsContext.Provider>
  );
};

export const useTaskGroupSettingsContext = () => useContext(TaskGroupSettingsContext);
